module.exports = __webpack_public_path__ + "img/app_promo_1_ja.b7c98eb2.png";